import { render } from "./App.vue?vue&type=template&id=b776458c"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=b776458c&lang=css"

import exportComponent from "../node_modules/.pnpm/vue-loader@17.2.2_vue@3.3.4+webpack@5.87.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__